export default __webpack_public_path__ + "static/media/2187.ac1533de.png";